/* eslint-disable no-unused-vars */
import {
  GET_COURSEOUTLINEREGISTRATION,
  GET_COURSEOUTLINEREGISTRATIONS,
  GET_COURSEOUTLINEREGISTRATIONS_BY_FILTER,
  ADD_COURSEOUTLINEREGISTRATION,
  UPDATE_COURSEOUTLINEREGISTRATION,
  DELETE_COURSEOUTLINEREGISTRATION
} from '@/queries/modules/courses/course-outline-registration.js';

import {apolloClient} from '@/setup/apollo-setup';
import {getField, updateField} from 'vuex-map-fields';
import {error, newItemSuccess, updateItemSuccess} from '@/utils/notification';

//
// initial state
const state = {
  courseOutlineRegistration: {
    id: '',
    academicPeriodId: '',
    periodCode: '',
    courseOutlineId: '',
    degreeId: '',
    subjectGroupId: '',
    subjectId: '',
    subjectCode: '',
    subjectName: '',
    teacherId: '',
    teacherCode: '',
    classSections: [],
  },
  courseOutlineRegistrations: [],
  processing: false,
  error: null,
  success: null,
};

//
// getters
const getters = {
  getField
};

//
// mutations
const mutations = {
  updateField,
  clearError: (state) => {
    state.error = null;
  },
  setError: (state, payload) => {
    state.error = payload;
    state.success = null;
    state.processing = false;
  },
  setSuccess: (state, payload) => {
    state.error = null;
    state.success = payload;
    state.processing = false;
  },
  setProcessing: (state, payload) => {
    state.processing = payload;
  },
  setCourseOutlineRegistrations: (state, payload) => {
    state.courseOutlineRegistrations = payload ? payload : [];
  },
  setCourseOutlineRegistration: (state, payload) => {
    state.courseOutlineRegistration = payload;
  },
  setSelectedCourseOutlineRegistration: (state, payload) => {
    state.courseOutlineRegistration = {...payload};
  },
  clearSelectedCourseOutlineRegistration: (state) => {
    state.courseOutlineRegistration = {
      id: '',
      academicPeriodId: '',
      periodCode: '',
      courseOutlineId: '',
      degreeId: '',
      subjectGroupId: '',
      subjectId: '',
      subjectCode: '',
      subjectName: '',
      teacherId: '',
      teacherCode: '',
      classSections: [],
    }
  }
};

//
// actions
const actions = {
  getCourseOutlineRegistration: async ({commit}, id) => {
    commit('setProcessing', true);

    apolloClient
      .query({
        query: GET_COURSEOUTLINEREGISTRATION,
        variables: {
          id: id
        }
      })
      .then(({data}) => {
        commit('setCourseOutlineRegistration', data.getCourseOutlineRegistration);
        commit('setSuccess', null);
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  getCourseOutlineRegistrations: async ({commit}) => {
    commit('setProcessing', true);

    apolloClient
      .query({
        query: GET_COURSEOUTLINEREGISTRATIONS,
        fetchPolicy: 'network-only'
      })
      .then(({data}) => {
        commit('setCourseOutlineRegistrations', data.getCourseOutlineRegistrations);
        commit('setSuccess', null);
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  getCourseOutlineRegistrationsByFilter: async ({commit}, payload, useState = true) => {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_COURSEOUTLINEREGISTRATIONS_BY_FILTER,
          variables: payload,
          fetchPolicy: 'network-only'
        });

      const {data, errors} = await result;

      if (errors) {
        commit('setError', error(errors));
        return [];
      } else {
        if (useState) {
          commit('setCourseOutlineRegistrations', data.getCourseOutlineRegistrationsByFilter);
        }
        commit('setSuccess', null);
        return data.getCourseOutlineRegistrationsByFilter
      }

    } catch (e) {
      commit('setError', error(e));
      return [];
    }
  },
  /*addCourseOutlineRegistration: async ({commit}, payload) => {
    commit('setProcessing', true);
    console.log('payload');
    console.log(payload);
    await apolloClient
      .mutate({
        mutation: ADD_COURSEOUTLINEREGISTRATION,
        variables: payload,
      })
      .then(({data}) => {
        const courseOutlines = [...state.courseOutlines];
        courseOutlines.push(data.addCourseOutlineRegistration);
        commit('setCourseOutlineRegistrations', courseOutlines);
        commit('setSuccess', newItemSuccess(data.addCourseOutlineRegistration.nameLocal));
      })
      .catch((err) => {
        commit('setError', error(err));
      });
  },*/
  updateCourseOutlineRegistration: async ({commit}, payload) => {
    commit('setProcessing', true);

    apolloClient
      .mutate({
        mutation: UPDATE_COURSEOUTLINEREGISTRATION,
        variables: payload
      })
      .then(({data}) => {
        const index = state.courseOutlines.findIndex(courseOutline => courseOutline.id === data.updateCourseOutlineRegistration.id);
        const courseOutlines = [
          ...state.courseOutlines.slice(0, index),
          data.updateCourseOutlineRegistration,
          ...state.courseOutlines.slice(index + 1)
        ];

        commit('setCourseOutlineRegistrations', courseOutlines);
        commit('setSuccess', updateItemSuccess(data.updateCourseOutlineRegistration.nameLocal));
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  /*deleteCourseOutlineRegistration: async ({commit}, payload) => {
    commit('setProcessing', true);

    apolloClient
      .mutate({
        mutation: DELETE_COURSEOUTLINEREGISTRATION,
        variables: payload
      })
      .then(({data}) => {
        const index = state.courseOutlines.findIndex(courseOutline => courseOutline.id === data.deleteCourseOutlineRegistration.id);
        const courseOutlines = [
          ...state.courseOutlines.slice(0, index),
          ...state.courseOutlines.slice(index + 1)
        ];

        commit('setCourseOutlineRegistrations', courseOutlines);
        commit('setSuccess', deleteItemSuccess(data.deleteCourseOutlineRegistration.nameLocal));
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },*/
  selectedCourseOutlineRegistration: async ({commit}, payload) => {
    commit('setSelectedCourseOutlineRegistration', payload);
  },
  clearSelectedCourseOutlineRegistration: async ({commit}) => {
    commit('clearSelectedCourseOutlineRegistration');
  },

  /**
   *  Action to Get Course Outline Registration List
   *
   *   @param  {Object} context Vuex context object.
   *     @property {Vuex method (Function)} commit : "To commit a mutation"
   *
   */

  async getCourseOutlineRegistrationList({commit}) {
    // commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_COURSEOUTLINEREGISTRATIONS,
          fetchPolicy: 'network-only'
        })
      const { data } = await result;

      // TODO: Handle after success;
      return { status: { success: true, error: false, message: "" }, data: [ ...data.getCourseOutlineRegistrations ] };

    } catch (e) {
      // commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }};
    }
  },


  /**
   *  Action to Add Course Outline Registration
   *
   *   @param  {Object} context Vuex context object.
   *     @property {Vuex method (Function)} commit : "To commit a mutation"
   *
   *   @param  {Object} payload Contain requires inputs for adding data
   *     @property {CourseOutlineRegistrationInput (Array), required} courseOutlineRegistrationInput : [{
          academicPeriodId: "", // {String} Get it from filter selection.
          periodCode: "",       // {String} Get it from filter selection.
          degreeId: "",         // {String} Get it from filter selection.
          subjectGroupId: "",   // {String} Get it from filter selection.
          subjectId: "",        // {String} Get it from Course Outline Selection.
          subjectCode: "",      // {String} "----------------------------------"
          subjectName: "",      // {String} "----------------------------------"
          courseOutlineId: "",  // {String} "----------------------------------"
          teacherId: "",        // {String} "----------------------------------"
          teacherCode: "",      // {String} "----------------------------------"
        }]
   *   @param  {Boolean} useState boolean if true method will set state will return data, Default: true
   *
   */

  async addCourseOutlineRegistration({commit}, payload, useState) {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
        .mutate({
          mutation: ADD_COURSEOUTLINEREGISTRATION,
          variables: payload
        });

      const {data, errors} = await result;

      if (errors) {
        commit('setError', error(errors));
        return {status: {success: false, error: true, message: "", full: errors}}
      } else {

        if (useState) {
          const courseOutlineRegistrations = [...state.courseOutlineRegistrations];
          courseOutlineRegistrations.concat(data.addCourseOutlineRegistration);
          commit('setCourseOutlineRegistrations', courseOutlineRegistrations);
        }

        commit('setSuccess', newItemSuccess(data.addCourseOutlineRegistration[0].subjectName));
        return {
          status: {success: true, error: false, message: ""},
          data: [...data.addCourseOutlineRegistration]
        };
      }

    } catch (e) {
      commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }}
    }


  },


  /**
   *  Action to Delete Course Outline Registration
   *
   *   @param  {Object} context Vuex context object.
   *     @property {Vuex method (Function)} commit : "To commit a mutation"
   *
   *   @param  {Object} payload Contain requires inputs for adding data
   *     @property {ID (String), required} id : "ID of a Course Outline Registration"
   *
   */

  async deleteCourseOutlineRegistration({ commit }, payload) {
    // commit('setProcessing', true);
    try {
      const result = await apolloClient
        .mutate({
          mutation: DELETE_COURSEOUTLINEREGISTRATION,
          variables: payload
        })
      const { data } = await result;
      return data.deleteCourseOutlineRegistration;
    } catch (e) {
      // commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }}
    }
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
